/**
 * Цель задачи (регламент, форма, поле) больше не существует: повтор не поможет,
 * задача не блокирует завершение регламентов заявки
 */
export const PHOTO_QUEUE_STALE_TARGET_CODE = 'stale_target';

export function isStalePhotoQueueTask(task: {
  readonly state: string;
  readonly lastError?: { readonly code: string };
}): boolean {
  return (
    task.state === 'failed' &&
    task.lastError?.code === PHOTO_QUEUE_STALE_TARGET_CODE
  );
}

export class PhotoQueueTaskExecutionError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly retryable: boolean,
    readonly httpStatus?: number,
  ) {
    super(message);
    this.name = 'PhotoQueueTaskExecutionError';
  }
}
